const FIXED_HEADER_SIZE = 30;

export function decodeDsb1(input) {
    const bytes = input instanceof Uint8Array ? input : new Uint8Array(input);
    if (bytes.byteLength < FIXED_HEADER_SIZE) {
        throw new Error('DSB1 payload is too short');
    }

    const magic = new TextDecoder('ascii').decode(bytes.subarray(0, 4));
    if (magic !== 'DSB1') throw new Error(`Invalid DSB1 magic: ${magic}`);

    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const columnCount = view.getUint8(4);
    const rowCount = view.getUint32(5, true);
    const count = view.getUint32(9, true);
    const time = new TextDecoder('ascii').decode(bytes.subarray(13, 28));
    const metadataLength = view.getUint16(28, true);
    const valuesOffset = FIXED_HEADER_SIZE + metadataLength;
    const expectedLength = valuesOffset + (rowCount * columnCount * 4);

    if (columnCount === 0 || rowCount === 0 || expectedLength !== bytes.byteLength) {
        throw new Error('Invalid DSB1 structure');
    }

    const metadata = metadataLength > 0
        ? new TextDecoder('utf-8').decode(bytes.subarray(FIXED_HEADER_SIZE, valuesOffset))
        : null;
    const timeAndData = new Array(rowCount);
    let offset = valuesOffset;

    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        const row = new Array(columnCount);
        for (let columnIndex = 0; columnIndex < columnCount; columnIndex++) {
            const value = view.getFloat32(offset, true);
            if (!Number.isFinite(value)) throw new Error('DSB1 contains a non-finite value');
            row[columnIndex] = value;
            offset += 4;
        }
        timeAndData[rowIndex] = row;
    }

    return { columnCount, rowCount, count, time, metadata, timeAndData };
}
